<iframe (load)="initIframe()" #iframe *ngIf="safeIframeSrcUrl" [src]="safeIframeSrcUrl"></iframe>
